/**
 * Runtime Environment Variable Helper for Vite SPA
 *
 * Supports:
 * 1. Docker runtime injection via `window.__ENV` (for multi-environment container deployments)
 * 2. Vite dev/build environment variables via `import.meta.env`
 */
export function env(key: string): string | undefined {
  if (typeof window !== 'undefined' && (window as any).__ENV && (window as any).__ENV[key] !== undefined) {
    return (window as any).__ENV[key]
  }

  try {
    const metaEnv = typeof import.meta !== 'undefined' ? (import.meta as any).env : undefined
    if (metaEnv) {
      if (metaEnv[key] !== undefined) return metaEnv[key]
      const viteKey = `VITE_${key.replace(/^NEXT_PUBLIC_/, '')}`
      if (metaEnv[viteKey] !== undefined) return metaEnv[viteKey]
    }
  } catch {
    // Ignore in environments where import.meta is not supported
  }

  return undefined
}
